import { render, staticRenderFns } from "./previewModel.vue?vue&type=template&id=78b65df0&scoped=true"
import script from "./previewModel.vue?vue&type=script&lang=js"
export * from "./previewModel.vue?vue&type=script&lang=js"
import style0 from "./previewModel.vue?vue&type=style&index=0&id=78b65df0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b65df0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b65df0')) {
      api.createRecord('78b65df0', component.options)
    } else {
      api.reload('78b65df0', component.options)
    }
    module.hot.accept("./previewModel.vue?vue&type=template&id=78b65df0&scoped=true", function () {
      api.rerender('78b65df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/previewFrom/previewModel.vue"
export default component.exports